var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSgi({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 396,
    height: 108,
    viewBox: "0 0 396 108",
    enableBackground: "new 0 0 396 108",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6BBE45",
    d: "M32.721,78.586L20.855,80.32C13.186,83.941,8.844,91.893,7.684,99.85h88.277 c6.223-0.574,12.451-4.623,15.199-10.412l7.67-24.738c1.301-4.781-0.58-9.258-2.461-13.166c-2.314-4.488-6.949-6.369-10.998-7.957 l-63.967-0.439l-2.027-0.574c0.141-5.209,2.174-9.404,3.762-13.887h62.813l9.404-1.734c8.104-3.047,11.578-11.578,12.879-19.102 H38.943C33.881,9,28.813,12.322,25.771,17.098l-7.23,22.57c-0.293,4.775-1.447,10.705,1.014,14.613 c3.035,4.922,7.951,8.098,13.166,9.404l65.268,0.721C96.4,69.035,95.82,74.25,93.5,78.586H32.721z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#6BBE45",
    d: "M141.406,17.537l-11.725,38.479l-6.656,24.018l1.447,9.404c2.461,5.502,7.67,9.979,13.898,10.412 l75.686,0.293c5.068-1.447,9.984-4.916,13.166-9.691l6.949-22.283c0.434-3.902,0.867-8.678-0.287-12.439 c-1.887-5.643-7.236-10.992-13.318-11.865l-53.396,0.434l1.734,7.523c2.889,5.789,8.25,10.998,14.613,12.152l29.818,0.727 l-3.768,14.32h-64.26l-1.154-1.16l12.879-45.135l2.174-4.049h66.568l8.684-3.182c6.949-3.908,9.123-10.857,10.424-17.654h-87.85 C150.957,8.854,145.309,11.889,141.406,17.537z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#6BBE45",
    d: "M256.455,21.732l-17.801,59.309c-1.154,6.949-4.336,12.299-5.936,19.102h13.611 c6.797-1.881,11.865-6.656,14.613-13.166l23.883-78.844h-11.725C266.012,9,258.916,14.93,256.455,21.732z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFCC2D",
    d: "M289.016,20.572l-14.174,48.029l-10.137,32.262c4.055,0.146,7.822-0.141,11.438-1.014 c4.922-2.602,9.551-7.523,10.418-12.873l18.814-62.209l5.936-16.641h-6.949C297.559,8.854,290.902,13.922,289.016,20.572z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFCC2D",
    d: "M317.24,18.258l-19.102,65.25l-5.936,17.355c4.055,0,8.25,0.146,11.725-1.447 c3.615-1.447,6.949-4.482,8.104-8.244l19.682-68.139l5.648-14.906h-5.936C324.764,8.854,320.135,12.615,317.24,18.258z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFCC2D",
    d: "M320.281,100.863c6.943,0.727,12.732-2.021,16.066-6.943l25.611-85.5 c-6.797-0.727-12.732,2.021-15.633,6.943l-17.361,56.713L320.281,100.863z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFCC2D",
    d: "M375.125,15.363l-26.338,85.793c5.502,0.287,10.711-1.014,13.898-5.93l26.338-86.373h-5.789 C379.76,9.58,376.871,12.762,375.125,15.363z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "_x3C_Slice_x3E__2_",
    fill: "none",
    width: 396,
    height: 108
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSgi);
export default __webpack_public_path__ + "static/media/sgi.e54a696386b4470d272aeb24b8e4ee35.svg";
export { ForwardRef as ReactComponent };